const FLUSH_TIMEOUT_MS = 15000;

/**
 * Waits for the AutoSaver to finish persisting pending transcript edits (including
 * speaker-tag changes) before stage completion or navigation.
 */
export const flushEditorSave = () =>
  new Promise((resolve) => {
    let settled = false;

    const finish = (success) => {
      if (settled) return;
      settled = true;
      window.removeEventListener("editor:autosave:complete", onComplete);
      clearTimeout(timeoutId);
      resolve(success);
    };

    const onComplete = (e) => {
      finish(e?.detail?.success !== false);
    };

    const timeoutId = setTimeout(() => finish(false), FLUSH_TIMEOUT_MS);

    window.addEventListener("editor:autosave:complete", onComplete);
    window.dispatchEvent(new CustomEvent("saveChanges"));
  });
